import { Fragment } from "react"; 
import { Outlet } from "react-router-dom";


const SalesIndexPage = () => {
  return (
    <Fragment>
        <Outlet />
    </Fragment>
  )
}

export default SalesIndexPage; 
